import http from "../../http";

const profit = {

    selectInvokePage(r) {
        return http.spin.get("/gateway/api/merchant/invoke/v1/selectInvokePage", r)
    },
}
export default profit
